import { NgModule } from '@angular/core';
import {GroupsModule} from './groups/groups.module';
import {RulesModule} from './rules/rules.module';
import {RoutingService} from './services/routing.service';

@NgModule({
  declarations: [
  ],
  imports: [
    GroupsModule,
    RulesModule
  ],
  providers: [
    RoutingService
  ]
})
export class RoutingModule { }
